import React from 'react';
import { Users, User, Calendar, Briefcase, Award } from 'lucide-react';

const BusinessEmployeesSection = ({ employees, businessEmployeeContext }) => {
  // Alias context
  const businessEmployee = businessEmployeeContext;

  return (
    <div className="bg-white rounded-2xl shadow-xl border border-orange-200 p-6">
      <div className="flex items-center gap-2 mb-6">
        <Users className="h-5 w-5 text-orange-500" />
        <h3 className="text-xl font-semibold text-gray-800">
          Empleados Registrados
        </h3>
      </div>

      {employees && employees.length > 0 ? (
        <div className="space-y-4">
          {employees.map((employee) => {
            // Safe navigation for formatting helper
            const formatted = businessEmployee?.formatEmployeeData
              ? businessEmployee.formatEmployeeData(employee)
              : { 
                  fullName: `${employee.employee_first_name} ${employee.employee_last_name}`,
                  formattedStartDate: employee.employee_start_date || 'N/A',
                  tenure: ''
                };

            return (
              <div 
                key={employee.employee_id || employee.id} 
                className="border border-gray-200 rounded-lg p-4 hover:bg-orange-50 transition-colors duration-200"
              >
                <div className="flex justify-between items-start">
                  <div className="flex items-start gap-4">
                    {/* Avatar Placeholder */}
                    <div className={`p-3 rounded-full ${
                      employee.employee_is_owner 
                        ? 'bg-orange-100 text-orange-600' 
                        : 'bg-blue-100 text-blue-600'
                    }`}>
                      <User className="h-6 w-6" />
                    </div>

                    <div>
                      <h4 className="font-medium text-gray-800 text-lg flex items-center gap-2">
                        {formatted.fullName}
                        {employee.employee_is_owner && (
                          <span className="inline-flex items-center px-2 py-0.5 rounded text-xs font-bold bg-orange-100 text-orange-700 border border-orange-200">
                            <Award className="w-3 h-3 mr-1" />
                            Propietario
                          </span>
                        )}
                      </h4>

                      <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mt-2 text-sm text-gray-600">
                        <div className="flex items-center gap-1">
                          <Briefcase className="h-4 w-4 text-gray-400" />
                          <span className="capitalize">
                            {employee.employee_position || (employee.employee_is_owner ? 'Dueño' : 'Empleado')}
                          </span>
                        </div>
                        
                        <div className="flex items-center gap-1">
                          <Calendar className="h-4 w-4 text-gray-400" />
                          <span>Contratado: {formatted.formattedStartDate}</span>
                        </div>
                      </div>

                      <div className="mt-2">
                        <span className={`inline-flex px-2 py-1 text-xs rounded-full font-medium ${
                          employee.employee_status === 'active'
                            ? 'bg-green-100 text-green-700'
                            : 'bg-red-100 text-red-700'
                        }`}>
                          {employee.employee_status === 'active' ? 'Activo' : 'Inactivo'}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Tenure Display */}
                  {formatted.tenure && (
                    <div className="hidden sm:block text-right">
                      <p className="text-xs text-gray-500 uppercase font-semibold tracking-wider">Antigüedad</p>
                      <p className="text-sm font-medium text-gray-800">{formatted.tenure}</p>
                    </div>
                  )}
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <div className="text-center py-12 bg-gray-50 rounded-lg border border-dashed border-gray-300">
          <Users className="h-12 w-12 text-gray-300 mx-auto mb-3" />
          <h4 className="text-lg font-medium text-gray-700">No hay empleados registrados</h4>
          <p className="text-gray-500 text-sm mt-1">
            No se encontraron registros de personal para este negocio.
          </p>
        </div>
      )}
    </div>
  );
};

export default BusinessEmployeesSection;